/** Rotas acessíveis sem sessão: um AUTH_CLEARED nelas não redireciona para o login. */
export const PUBLIC_ROUTES = [
  "/",
  "/login",
  "/register",
  "/doctor-login",
  "/verify-email",
  "/forgot-password",
  "/reset-password",
  "/onboarding",
  "/privacy",
  "/terms",
  "/security",
  "/shared",
  "/excluir-conta",
  "/cancelar-exclusao",
] as const;
